import { styled } from "styled-components";

export const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid ${({ theme }) => theme.colors.default[100]};
  padding-bottom: 24px;
`;

export const CartItemsContainer = styled.div`
  display: flex;
  flex-direction: column;

  > * {
    padding: 8px 16px;
    border-radius: 12px;

    &:nth-of-type(even) {
      background: ${({ theme }) => theme.colors.base};
    }
  }
`;
